/**
 * Whether a scheduled CPM campaign should show a concrete start date.
 * Missing or unparseable values stay dateless ("Em breve" without a day).
 */
export function hasScheduledStartDate(startDate?: string | null): boolean {
  if (startDate == null || startDate === '') return false;
  return !Number.isNaN(new Date(startDate).getTime());
}
